module.exports = __webpack_public_path__ + "img/level_07_platinum.61a08bf9.svg";